import i18n from '../../../i18n';
import { ReceiveExceptionStatus } from '../../../services/receive-exception/types';

export const SELECT_EMPTY_VALUE = {
  label: '-',
  value: '',
  disabled: false,
};

export enum ExceptionTypes {
  DAMAGED_SHIPMENT = 'DAMAGED_SHIPMENT',
  INCORRECT_DELIVERY_SITE = 'INCORRECT_DELIVERY_SITE',
  INVALID_SHIPMENT_REFERENCE = 'INVALID_SHIPMENT_REFERENCE',
  INVALID_PO = 'INVALID_PO',
  INVALID_MODEL = 'INVALID_MODEL',
  INVALID_SERIAL = 'INVALID_SERIAL',
  AAR_CHECK_FAILED = 'AAR_CHECK_FAILED',
  DUPLICATE_SERIAL = 'DUPLICATE_SERIAL',
  SERIAL_UNIQUENESS_FAILED = 'SERIAL_UNIQUENESS_FAILED',
  OVERAGE_HIGHER_THAN_EXPECTED = 'OVERAGE_HIGHER_THAN_EXPECTED',
  OVERAGE_HIGHER_THAN_PO = 'OVERAGE_HIGHER_THAN_PO',
  SHORT_SHIPMENT_ASN = 'SHORT_SHIPMENT_ASN',
  SHORT_SHIPMENT_PO = 'SHORT_SHIPMENT_PO',
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  OTHER = 'OTHER',
  SHIPMENT_REFERENCE_NOT_AVAILABLE = 'SHIPMENT_REFERENCE_NOT_AVAILABLE',
  SHIPMENT_REFERENCE_NOT_SCANNABLE = 'SHIPMENT_REFERENCE_NOT_SCANNABLE',
  SHIPMENT_REFERENCE_DAMAGED_OR_TORN = 'SHIPMENT_REFERENCE_DAMAGED_OR_TORN',
}

export enum ResolutionCodes {
  RETURN_TO_VENDOR = 'RETURN_TO_VENDOR',
  MATERIAL_DESTROY = 'MATERIAL_DESTROY',
  CREATE_RECEIPT = 'CREATE_RECEIPT',
  OTHER = 'OTHER',
}

export enum OrderTypes {
  PO = 'Purchase Order',
  RMA = 'RMA',
  ASN_PO = 'Shipment - Purchase Order',
  JANUS = 'Janus',
  OMD = 'OMD',
  FA = 'FA',
}

export type ExceptionTypeOptionsProps = {
  label: string;
  value: string;
  disabled?: boolean;
};

export const OrderTypeOptions = Object.keys(OrderTypes).map((type) => {
  const label: string = OrderTypes[type];
  return {
    label: i18n.t(label),
    value: type,
  };
});

export const ResolutionCodeOptions = [
  SELECT_EMPTY_VALUE,
  {
    label: i18n.t('Return to Vendor'),
    value: ResolutionCodes.RETURN_TO_VENDOR,
  },
  {
    label: i18n.t('Material Destroy / E-Waste'),
    value: ResolutionCodes.MATERIAL_DESTROY,
  },
  {
    label: i18n.t('Create Receipt'),
    value: ResolutionCodes.CREATE_RECEIPT,
  },
  {
    label: i18n.t('Other'),
    value: ResolutionCodes.OTHER,
  },
];

export const ExceptionStatusOptions = [
  SELECT_EMPTY_VALUE,
  {
    label: i18n.t(`receive-exception.status-assigned`),
    value: ReceiveExceptionStatus.ASSIGNED,
  },
  {
    label: i18n.t(`receive-exception.status-pending-action`),
    value: ReceiveExceptionStatus.PENDING_ACTION,
  },
  {
    label: i18n.t(`receive-exception.status-resolved`),
    value: ReceiveExceptionStatus.RESOLVED,
  },
  {
    label: i18n.t(`receive-exception.status-cancelled`),
    value: ReceiveExceptionStatus.CANCELLED,
  },
];

export const nonUpdatableFormFields = [
  'exceptionType',
  'shipmentReferenceNumber',
  'orderType',
  'orderNumber',
  'orderLineNumber',
  'entireOrder',
  'model',
  'legacyModelId',
];

export const updatableFormFields = [
  'title',
  'site',
  'holdingLocation',
  'trackingNumber',
  'serials',
  'quantity',
  'tags',
  'assignedToId',
  'assignedToType',
];

export const ExceptionTypeGroupNamesMapping = {
  DAMAGED_SHIPMENT: [
    {
      label: 'LOGISTICS',
      value: 'LOGISTICS',
    },
  ],
  INCORRECT_DELIVERY_SITE: [
    {
      label: 'LOGISTICS',
      value: 'LOGISTICS',
    },
  ],
  INVALID_SHIPMENT_REFERENCE: [
    {
      label: 'LOGISTICS',
      value: 'LOGISTICS',
    },
    {
      label: 'VMI TEAM',
      value: 'VMI TEAM',
    },
  ],
  INVALID_PO: [
    {
      label: 'LOGISTICS',
      value: 'LOGISTICS',
    },
    {
      label: 'VMI TEAM',
      value: 'VMI TEAM',
    },
    {
      label: 'NW TPMS',
      value: 'NW TPMS',
    },
  ],
  INVALID_MODEL: [
    {
      label: 'IPS ORDERING TEAM',
      value: 'IPS ORDERING TEAM',
    },
    {
      label: 'VMI TEAM',
      value: 'VMI TEAM',
    },
    {
      label: 'DCS PARTS ADMIN',
      value: 'DCS PARTS ADMIN',
    },
  ],
  INVALID_SERIAL: [
    {
      label: 'LOGISTICS',
      value: 'LOGISTICS',
    },
    {
      label: 'VMI TEAM',
      value: 'VMI TEAM',
    },
  ],
  AAR_CHECK_FAILED: [
    {
      label: 'VMI TEAM',
      value: 'VMI TEAM',
    },
    {
      label: 'IPS ORDERING TEAM',
      value: 'IPS ORDERING TEAM',
    },
    {
      label: 'NW TPMS',
      value: 'NW TPMS',
    },
  ],
  DUPLICATE_SERIAL: [
    {
      label: 'LOGISTICS',
      value: 'LOGISTICS',
    },
    {
      label: 'VMI TEAM',
      value: 'VMI TEAM',
    },
  ],
  SERIAL_UNIQUENESS_FAILED: [
    {
      label: 'LOGISTICS',
      value: 'LOGISTICS',
    },
    {
      label: 'VMI TEAM',
      value: 'VMI TEAM',
    },
  ],
  OVERAGE_HIGHER_THAN_EXPECTED: [
    {
      label: 'LOGISTICS',
      value: 'LOGISTICS',
    },
  ],
  OVERAGE_HIGHER_THAN_PO: [
    {
      label: 'IPS ORDERING TEAM',
      value: 'IPS ORDERING TEAM',
    },
    {
      label: 'NW TPMS',
      value: 'NW TPMS',
    },
  ],
  SHORT_SHIPMENT_PO: [
    {
      label: 'NW TPMS',
      value: 'NW TPMS',
    },
  ],
  SYSTEM_ERROR: [
    {
      label: 'LOGISTICS',
      value: 'LOGISTICS',
    },
  ],
  SHIPMENT_REFERENCE_NOT_AVAILABLE: [
    {
      label: 'IPS ORDERING TEAM',
      value: 'IPS ORDERING TEAM',
    },
  ],
  SHIPMENT_REFERENCE_NOT_SCANNABLE: [
    {
      label: 'IPS ORDERING TEAM',
      value: 'IPS ORDERING TEAM',
    },
  ],
  SHIPMENT_REFERENCE_DAMAGED_OR_TORN: [
    {
      label: 'IPS ORDERING TEAM',
      value: 'IPS ORDERING TEAM',
    },
  ],
};
